import { globalEvent } from '@shared/easyfy.core';

export default class ScrollTo {
  static Instance: ScrollTo;
  static scrollBehavior: ScrollBehavior;
  
  // If the event is applied to a <a>-tag with hash-href, the value will show in browser url
  static showAnchor: boolean; 

  constructor(scrollBehavior: ScrollBehavior, showAnchor: boolean) {
    ScrollTo.Instance = this;

    ScrollTo.scrollBehavior = scrollBehavior;
    ScrollTo.showAnchor = showAnchor;
    
    globalEvent({
      type: 'click',
      events: [
        {
          event: 'scroll-to',
          callback: this.onScrollTo,
        },
      ],
    });
  }
  
  onScrollTo(e: any) {

    if (!ScrollTo.showAnchor && e?.preventDefault) e.preventDefault();

    var element: HTMLElement = e.target as HTMLElement;
    
    if (element.getAttribute('data-event') != "scroll-to"){
      element = element.closest('[data-event="scroll-to"]');
    }
    
    const targetName = element.attributes['data-target']?.value; 

    const targetElement = document.querySelector('[data-container="' + targetName + '"]');
    if (targetElement == null) {
      return false;
    }

    targetElement.scrollIntoView({behavior: ScrollTo.scrollBehavior }); 

    return false;
  }
}